import React from 'react';
import { galleryPublicPropTypes } from 'shared/proptypes/ContentModule';
import WysiwygContent from 'shared/components/WysiwygContent';
import PhotoAlbum from 'shared/components/ContentModule/components/PhotoAlbum';

const ContentModuleViewGallery = ({
  title,
  description,
  display,
  margin,
  photos,
}) => (
  <>
    {title && (<h2>{title}</h2>)}
    {description && (
      <WysiwygContent>{description}</WysiwygContent>
    )}
    <PhotoAlbum
      photos={photos}
      display={display}
      margin={margin}
    />
  </>
);

ContentModuleViewGallery.propTypes = galleryPublicPropTypes;

export default ContentModuleViewGallery;
